import { z } from 'zod';
import { TenantIdentityRequestSchema, TenantSummarySchema } from '../../../../entities/tenant/tenant.schema';
/**
 * Add Tenant Request Schema
 * POST /api/v2/tenant
 * Contains the tenant details (name, slug, type) required to create a new tenant
 */ export const AddTenantRequestSchema = TenantIdentityRequestSchema.extend({
    /** Partner firm's HubSpot company id (company-centric anchor for partners). */ hubspotPartnerCompanyId: z.string().optional(),
    /**
   * Confirm overwriting an existing HubSpot company↔tenant link. Transient
   * action flag (not persisted) — only honoured when the linked company already
   * points at a different tenant; otherwise ignored.
   */ forceHubspotLink: z.boolean().optional()
});
/**
 * Add Tenant Response Schema
 * Returned on successful tenant creation
 * Contains the created tenant object with all its properties
 */ export const AddTenantResponseSchema = z.object({
    tenant: TenantSummarySchema
});
/**
 * Add Tenant Error Schema
 * Returned when tenant creation fails
 * Contains standard error information including status code, message, and error type
 */ export const AddTenantErrorSchema = z.object({
    statusCode: z.number(),
    message: z.string(),
    error: z.string()
});

//# sourceMappingURL=add-tenant.schema.js.map